<template>
  <div class="content-item">
    <h2 class="heading">Click forward after your cards arrive.</h2>
    <p class="text">Great Job!! Please let us know as soon as your cards arrive to complete the invitation video.</p>
  </div>
</template>

<script>
import { get } from 'lodash';
export default {
  name: 'Step7',
  props: {
    value: {
      type: Object,
    },
    source: {
      type: Object,
    },
  },
  computed: {
    backCards() {
      return get(this.source, 'back', []);
    },
  },
  data() {
    return {
      selected: {},
    };
  },
};
</script>
